// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1014":"1c7d44f3","4193":"75807d46"}[chunkId] + ".chunk.css";
};